import Notify from "./module/notify";
const notify = new Notify();

document.addEventListener("DOMContentLoaded", function() {

  const deeplinks = document.querySelectorAll('button.social-deeplink');
  if (deeplinks) {
    deeplinks.forEach(deeplink => {
      const url = deeplink.dataset.url;
      if (url) {
        deeplink.addEventListener("click", function() {
          copyTextToClipboard(url);
        });
      }
    })

    function fallbackCopyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      textArea.value = text;

      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
        notify.emit([
          {
            message: "Link kopiert",
            status: "success",
          },
        ]);
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
      }

      document.body.removeChild(textArea);
    }

    function copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(function() {
        console.log('Async: Copying to clipboard was successful!');
        notify.emit([
          {
            message: "Link kopiert",
            status: "success",
          },
        ]);
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
    }
  }
});



